import styled from 'styled-components';
import media from '../../../mediaqueries/media';

const MobileSectionheaderWrapper = styled.div`
height:100%;
._overlay{
  position: fixed;
  bottom: 0;
  top: 0;
  left: 0;
  right: 0;
  ${'' /* background: rgba(0,0,0,0.25); */}
  z-index: 999;
}
.headerWrapper{
  ${media.tablet`
   background:#fff;
    }
  `}
header.sectionHeader{
  background:#344177;
    display: flex;
    align-items: center;
    justify-content: space-between;
    min-height:92px;
    padding:0 15px;
    .menu-icon{
     cursor: pointer;
    float: right;
    height: 25px;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: all 0.5s ease-in-out 0s;
    -moz-transition: all 0.5s ease-in-out 0s;
    -o-transition: all 0.5s ease-in-out 0s;
    transition: all 0.5s ease-in-out 0s;
    width: 30px;
    z-index: 9;
   
    #notification-sign{
      width: 12px;
      height: 12px;
      border-radius: 12px;
      background: #e83c3c;
      top: -5px;
      right: -5px !important;
      position: absolute;
      z-index: 9;
      float: right;
      left: auto;
    }
      >span{
        background-color: #fff;
    border-radius: 0;
    display: block;
    height: 2.5px;
    left: 0;
    opacity: 1;
    position: absolute;
    -webkit-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: all 0.25s ease-in-out 0s;
    -moz-transition: all 0.25s ease-in-out 0s;
    -o-transition: all 0.25s ease-in-out 0s;
    transition: all 0.25s ease-in-out 0s;
    width: 30px;
        &:nth-child(1){
          top: 0;
        }
        &:nth-child(2){
          top: 10px;
        }
        &:nth-child(3){
          top: 20px;
        }
      }
    }
    .m-logo{
      text-align: center;
      >img{
        display: block;
        max-width: 120px;
        margin: 0;
      }
      >h3{
        color: #4eb0de;
        margin: 0;
        padding: 7px 0 0;
        font-size: 14px;
        text-transform: uppercase;
        font-weight: 300;
      }
    }
    .user-profile-info{
      .user__profile{
        font-family: 'Open Sans',sans-serif;
        margin-left: auto;
        position: relative;
        .dropdownmask{
            z-index:999;
            position: fixed;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0;
            background: rgba(0,0,0,0.2);
            pointer-events: none;
            -moz-backface-visibility: hidden;
            -webkit-backface-visibility: hidden;
            -webkit-backface-visibility: hidden;
            backface-visibility: hidden;
        }
        .thumb-inner{
           
            display: -webkit-box;
            display: -moz-box;
            display: -ms-flexbox;
            display: -webkit-flex;
            display: flex;
            -webkit-align-items: center;
            -webkit-box-align: center;
            -webkit-flex-align: center;
            align-items: center;
            -webkit-justify-content: center;
            justify-content: center;
            .down_arrow{
              margin-left:10px;
              position:relative;
              &:before{
                content: '';
                position: absolute;
                background: #f6c933;
                width: 15px;
                height: 15px;
                border-radius: 10px;
                left: -20px;
                top: 15px;
                border: 2px solid #344177;
              }
            }
            h1{
                font-family: 'Open Sans',sans-serif;
                font-size: 14px;
                font-weight:700;
                margin-right:15px;
            }
            >img{
                width: 40px;
                height: 40px;
                border-radius:50%;
                cursor: pointer;
            }
            .thumb-initials{
                background: #B4BBD6;
                width: 50px;
                height: 50px;
                -webkit-text-decoration: none;
                text-decoration: none;
                display: block;
                border-radius: 50%;
                color: #fff;
                line-height: 50px;
                cursor: pointer;
                text-align: center;
            }
        }
        .userDropdown{
            font-family: 'Open Sans', sans-serif;
            z-index: 1000;
            position: absolute;
            top: 60px;
            background: #344177;
            right: 0px;
            width: 270px;
            border-radius: 5px;
            padding:15px 30px;
            box-shadow: 2px 2px 10px 0 rgba(0, 0, 0, 0.13);
            -moz-backface-visibility: hidden;
            -webkit-backface-visibility: hidden;
            backface-visibility: hidden;
            &:before{
                content: '';
                width: 0;
                height: 0;
                border: 5px solid transparent;
                position: absolute;
                border-bottom-color: #344177;
                top: -10px;
                right: 18px;
            }
            .menu-header{
                font-family: 'Open Sans', sans-serif;
                border-bottom: 1px solid #485373;
                .profile-picture{
                    display: -webkit-box;
                    display: -moz-box;
                    display: -ms-flexbox;
                    display: -webkit-flex;
                    display: flex;
                    -webkit-align-items: center;
                    -webkit-box-align: center;
                    -webkit-flex-align: center;
                    align-items: center;
                    -webkit-justify-content: center;
                    justify-content: center;
                    margin-bottom: 10px;
                }
                .profile-name{
                    color: white;
                    margin: 20px 0 10px 0;
                    text-align: center;
                }
                .profile-status{
                    isplay: -webkit-box;
                    display: -moz-box;
                    display: -ms-flexbox;
                    display: -webkit-flex;
                    display: flex;
                    -webkit-align-items: center;
                    -webkit-box-align: center;
                    -webkit-flex-align: center;
                    align-items: center;
                    -webkit-justify-content: center;
                    justify-content: center;
                    color: white;
                    height: 25px;
                    margin-bottom: 10px;
                    font-size: 13px;
                    margin-left: -22px;
                    .status-online{
                        border-radius: 50%;
                        width: 12px;
                        height: 12px;
                        background-color: #a3e74c;
                        margin-right: 10px;
                    }
                }
            }
            .menu-links{
                margin: 15px 0 0;
                .nav-link{
                    font-family: 'Open Sans', sans-serif;
                    line-height: 35px;
                    color: white;
                    display: block;
                }
            }
        }
    }
    }
  
}
.linkRow{
  padding:20px 15px 30px;
  background:#fff;
  .linkRow-container{
    display: -webkit-box;
    display: -moz-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-flex-direction: row;
    flex-direction: column;
    align-items:center;
    .textBoxCont{
      // min-width: 470px;
      width:100%;
      >h1{
        font-size:1em !important;
        color:#344177;
        margin:0;
        padding:0 0 10px;
      }
      .phonefield{
        display: -webkit-box;
        display: -moz-box;
        display: -ms-flexbox;
        display: -webkit-flex;
        display: flex;
        -webkit-flex-direction: row;
        flex-direction: row;
        align-items:center;
        justify-content:space-between;

        .copylink{
          cursor: pointer;
          right: 0;
          max-width: 170px;
          min-width: 110px;
          font-size: 1em;
          border: 1px solid #4eb0de;
          border-radius: 10px;
          display: block;
          text-transform: capitalize;
          text-align: center;
          color: #ffffff;
          font-weight: 600;
          background: #4eb0de;
          padding: 15px 20px;
          border-top-left-radius: 0;
          border-bottom-left-radius: 0;
        }
        .copylink-textbox{
          background: #ffffff;
          padding: 15px 15px;
          width: 100%;
          border: 1px solid #b2b9d6;
          border-radius:10px 0 0 10px;
          &:focus{
            outline:none;
          }
        }
      }
    }

    .invite-source{
      width:100%;

      .invite-via{
        cursor: pointer;
          right: 0;
          min-width: 140px;
          width:100%;
          text-align:center;
          font-size: 1em;
          border: 1px solid #4eb0de;
          border-radius: 10px;
          display: block;
          text-transform: uppercase;
          color: #4eb0de;
          font-weight: 700;
          background: #ffffff;
          padding: 10px 20px;
          background-image:url('/images/downarrow.png');
          background-repeat: no-repeat;
          background-position: 95% center;
          background-size: 13px;
          margin: 10px 0 0;
      }
    }
  }
}
}


`;


export default (MobileSectionheaderWrapper);